import { GetterTree } from 'vuex'

import { CoreState } from './state'

export default {
} as GetterTree<CoreState, any>
